export function getRows(payload) {
  if (Array.isArray(payload?.data?.data)) return payload.data.data
  if (Array.isArray(payload?.data)) return payload.data
  return []
}

export function getPartyType(item) {
  const rawType = (
    item?.type ||
    item?.partyType ||
    item?.entityType ||
    item?.category ||
    item?.kind ||
    item?.role
  )

  if (typeof rawType === 'string') {
    const value = rawType.toLowerCase()
    if (['vendor', 'vendors', 'supplier', 'suppliers'].includes(value)) return 'vendor'
    if (['party', 'parties', 'customer', 'customers', 'client', 'clients'].includes(value)) return 'party'
  }

  if (item?.isVendor === true) return 'vendor'
  if (item?.isParty === true) return 'party'

  return null
}

export function filterByPartyType(items, type) {
  return items.filter((item) => getPartyType(item) === type)
}

export function getPartyName(item) {
  return item?.name || item?.partyName || item?.vendorName || ''
}
